@if (!equipment()) {
    <p class="text-muted mb-0">Pick a piece of equipment to see its work order history.</p>
} @else {
    <div class="wo-history-body">
        @if (showSummary() && summary) {
            <div class="wo-history-summary">
                <strong>{{ summary.equipment }}</strong>
                @if (summary.description) {
                    <span> — {{ summary.description }}</span>
                }
                @if (summary.category) {
                    <span class="text-muted"> · {{ summary.category }}</span>
                }
                @if (summary.hourReading != null) {
                    <span class="text-muted"> · Hours {{ summary.hourReading }}</span>
                }
                @if (summary.odoReading != null) {
                    <span class="text-muted"> · Odo {{ summary.odoReading }}</span>
                }
                @if (summary.lastCompletedWorkOrderDate || summary.lastCompletedWorkOrderNumber) {
                    <span class="text-muted">
                        · Last completed
                        @if (summary.lastCompletedWorkOrderDate) {
                            <span>{{ summary.lastCompletedWorkOrderDate | date: 'MM/dd/yyyy' }}</span>
                        }
                        @if (summary.lastCompletedWorkOrderNumber) {
                            <span> (WO {{ summary.lastCompletedWorkOrderNumber }})</span>
                        }
                    </span>
                }
            </div>
        }

        <div class="row action-toolbar">
            <div class="col-12">
                <form class="form-inline">
                    <action-toolbar-count [grid]="grid"></action-toolbar-count>
                    <action-toolbar-search name="historySearch" [(ngModel)]="grid.filter"></action-toolbar-search>
                    <div class="input-header-group">
                        <span class="input-header">Window</span>
                        <wj-combo-box
                            name="historyYears"
                            [ngModel]="years()"
                            (ngModelChange)="onYearsChanged($event)"
                            [itemsSource]="yearsOptions"
                            [displayMemberPath]="'display'"
                            [selectedValuePath]="'value'"
                            [isRequired]="true"
                        >
                        </wj-combo-box>
                    </div>
                </form>
            </div>
        </div>

        <div class="wo-history-grid-host">
            <wj-flex-grid
                #historyGrid
                class="wo-history-grid"
                (initialized)="grid.initialize(historyGrid)"
                (destroy)="grid.destroy()"
                [itemsSource]="grid.view"
            >
                <wj-flex-grid-filter></wj-flex-grid-filter>
                <wj-flex-grid-column [header]="'Source'" [binding]="'source'" [width]="90" [isReadOnly]="true">
                    <ng-template wjFlexGridCellTemplate cellType="Cell" let-cell="cell">
                        <span
                            class="wo-source-badge"
                            [class.wo-source-vista]="cell.item.source === 'Vista'"
                            [class.wo-source-webapps]="cell.item.source === 'WebApps'"
                        >
                            {{ cell.item.source }}
                        </span>
                    </ng-template>
                </wj-flex-grid-column>
                <wj-flex-grid-column [header]="'Work Order'" [binding]="'workOrderNumber'" [width]="110" [isReadOnly]="true">
                    <ng-template wjFlexGridCellTemplate cellType="Cell" let-cell="cell">
                        <a href="javascript:void(0)" (click)="onOpen(cell.item)" class="wo-link" title="Open this work order">
                            {{ cell.item.workOrderNumber }}
                        </a>
                    </ng-template>
                </wj-flex-grid-column>
                <wj-flex-grid-column [header]="'Status'" [binding]="'status'" [width]="90" [isReadOnly]="true"></wj-flex-grid-column>
                <wj-flex-grid-column
                    [header]="'Description'"
                    [binding]="'description'"
                    [width]="'*'"
                    [isReadOnly]="true"
                ></wj-flex-grid-column>
                <wj-flex-grid-column [header]="'Mechanic'" [binding]="'mechanicName'" [width]="160" [isReadOnly]="true"></wj-flex-grid-column>
                <wj-flex-grid-column
                    [header]="'Created'"
                    [binding]="'dateCreatedValue'"
                    [format]="'MM/dd/yyyy'"
                    [width]="100"
                    [isReadOnly]="true"
                ></wj-flex-grid-column>
                <wj-flex-grid-column
                    [header]="'Completed'"
                    [binding]="'dateCompletedValue'"
                    [format]="'MM/dd/yyyy'"
                    [width]="120"
                    [minWidth]="120"
                    [isReadOnly]="true"
                ></wj-flex-grid-column>
                <wj-flex-grid-column
                    [header]="'Items'"
                    [binding]="'itemCount'"
                    [width]="85"
                    [minWidth]="85"
                    [isReadOnly]="true"
                ></wj-flex-grid-column>
                <wj-flex-grid-column
                    [header]="'Notes'"
                    [binding]="'hasHeaderNotes'"
                    [width]="85"
                    [minWidth]="85"
                    [align]="'center'"
                    [isReadOnly]="true"
                >
                    <ng-template wjFlexGridCellTemplate cellType="Cell" let-cell="cell">
                        @if (cell.item.hasHeaderNotes) {
                            <span title="Has header notes">Yes</span>
                        }
                    </ng-template>
                </wj-flex-grid-column>
            </wj-flex-grid>
        </div>

        @if (!isLoading && grid.items.length === 0) {
            <p class="text-muted mt-2 mb-0">No work orders found for {{ equipment() }} in this window.</p>
        }
    </div>
}
